import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { useCommunicationsPage } from '../context/CommunicationsPageContext';

const SignaturePreview: FC = () => {
  const { t } = useTranslate();
  const { data } = useCommunicationsPage();

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px' }}>
      <p style={{ lineHeight: '24px' }}>
        <b>{data.signatureName}</b>
        <br />
        {data.signatureJobTitle}
      </p>
      <img
        src={data.signatureLogo}
        alt="signature logo"
        style={{ maxWidth: '100px' }}
      />
      <br />
      <p style={{ lineHeight: '18px', marginBottom: '2px' }}>
        <a
          href={`https://${data.signatureWebsite}`}
          target="_blank"
          rel="noreferrer"
          style={{ color: data.linkColor }}
        >
          {data.signatureWebsite}
        </a>
        <a
          href={`tel:${data.signaturePhone}`}
          style={{ color: data.linkColor }}
        >
          {data.signaturePhone && (
            <>
              {' '}
              | {t('Telephone')}: {data.signaturePhone}
            </>
          )}
        </a>
      </p>
      <p style={{ lineHeight: '18px', marginTop: '2px' }}>
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            data.signatureAddress
          )}`}
          target="_blank"
          rel="noreferrer"
          style={{ color: data.linkColor }}
        >
          {data.signatureAddress}
        </a>
      </p>
      <p style={{ color: 'grey', fontSize: '10px' }}>{data.signatureFooter}</p>
    </div>
  );
};

export default SignaturePreview;
